import React, { useState } from "react";

interface InfoItem {
  label: string;
  value: React.ReactNode;
}

interface InfoCardProps {
  title: string;
  items: InfoItem[];
  actions?: React.ReactNode;
}

export default function InfoCard({ title, items, actions }: InfoCardProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div style={{
      padding: isCollapsed ? "0.5rem 1rem" : "1rem",
      backgroundColor: "white",
      borderRadius: "8px",
      border: "1px solid #dee2e6",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      width: "100%",
      display: "flex",
      flexDirection: "column"
    }}>
      <h2 style={{ margin: 0, color: "#212529", fontSize: "1.1rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>{title}</span>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#6c757d",
            padding: "0.25rem 0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          title={isCollapsed ? "Expand" : "Collapse"}
        >
          {isCollapsed ? "▼" : "▲"}
        </button>
      </h2>
      {!isCollapsed && (
        <>
          <div style={{ 
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "0.5rem 1rem",
            color: "#6c757d",
            fontSize: "0.9rem",
            marginTop: "1rem"
          }}>
            {items.map((item, index) => (
              <div key={index} style={{ display: "inline-flex", gap: "0.25rem", whiteSpace: "nowrap" }}>
                {item.label && <strong style={{ color: "#212529" }}>{item.label}:</strong>} {item.value}
              </div>
            ))}
          </div>
          {actions && (
            <div style={{ marginTop: "0.5rem", paddingTop: "0.5rem", borderTop: "1px solid #dee2e6" }}>
              {actions}
            </div>
          )}
        </>
      )}
    </div>
  );
}

